import maplibregl from 'maplibre-gl';

import * as pmtiles from 'pmtiles';
import sources from './style/style.sources.json';
import layers from './style/style.layers.json';

const protocol = new pmtiles.Protocol();
maplibregl.addProtocol('pmtiles', protocol.tile);

/*  Exports
    ======================================================================================= */
function addSourcesAndLayersFromConfigToMap(mapboxMap) {
  Object.keys(sources).forEach(sourceId => mapboxMap.addSource(sourceId, sources[sourceId]));
  layers.forEach(layer => mapboxMap.addLayer(layer));

  // this are empty layers make sure the order of layers are always as intended
  for (let i = 0; i < 10; i += 1) {
    mapboxMap.addLayer({
      id: `z-index-${i}`,
      type: 'fill',
      source: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [],
        },
      },
      paint: {},
    });
  }

  ['City labels', 'Place labels', 'Road labels', 'Country labels', 'Capital city labels'].forEach((id) => {
    if (mapboxMap.getLayer(id)) mapboxMap.moveLayer(id, 'z-index-9');
  });

  return mapboxMap;
}

function mapFactory(mapEl) {
  const options = { 
    container: mapEl,
    attributionControl: false,
    style: `https://api.maptiler.com/maps/5c22ba3e-a7a2-4fdd-9cc0-2e9304b1812c/style.json?key=${import.meta.env.VITE_MAPTILER_TOKEN}`,
    center: [14.5057515, 46.0569465],
    zoom: 8,
  };

  const map = new maplibregl.Map(options)
  return map;
}

export {
  mapFactory,
  addSourcesAndLayersFromConfigToMap,
}